import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import React, { memo } from 'react';
import styles from './index.module.less';
export const Input = memo(({ size = 'middle', className, type, multiLine = false, fullWidth, round, leftAddon, rightAddon, ...rest }) => {
    return (_jsxs("div", { className: classnames(styles.container, className), children: [leftAddon ? _jsx("span", { className: styles.leftHolder, children: leftAddon }) : null, multiLine ? (_jsx("textarea", { className: classnames(styles.textarea, styles[size], {
                    [styles.fullWidth]: fullWidth,
                    [styles.round]: round,
                    [styles.hasLeft]: leftAddon,
                }), rows: 4, cols: 25, ...rest })) : (_jsx("input", { className: classnames(styles.input, styles[size], {
                    [styles.fullWidth]: fullWidth,
                    [styles.round]: round,
                    [styles.hasLeft]: leftAddon,
                }), type: type ?? 'text', ...rest })), rightAddon ? _jsx("span", { className: styles.rightHolder, children: rightAddon }) : null] }));
});
